document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.deadlines-table-row-toggle');
  const getRows = () => document.querySelectorAll('.deadlines-table-row');

  // Breakpoints
  let lastIsDesktop = window.matchMedia('(min-width: 960px)').matches;
  const isDesktop = () => window.matchMedia('(min-width: 960px)').matches;

  // Toggle row open/close
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const row = toggle.closest('.deadlines-table-row');
      if (row) {
        row.classList.toggle('is-open');
      }
    });
  });

  // Remove .is-open on breakpoint change
  window.addEventListener('resize', () => {
    const currentDesktop = isDesktop();
    if (currentDesktop !== lastIsDesktop) {
      getRows().forEach((row) => row.classList.remove('is-open'));
      lastIsDesktop = currentDesktop;
    }
  });
});